// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"479":"6a7bb2e9","594":"5702a1a8"}[chunkId] + ".js";
};